var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_922_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 10.8C10.4941 10.8 11.3 9.99406 11.3 8.99995C11.3 8.00584 10.4941 7.19995 9.50001 7.19995C8.5059 7.19995 7.70001 8.00584 7.70001 8.99995C7.70001 9.99406 8.5059 10.8 9.50001 10.8Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.911987 8.99999C2.05881 5.34857 5.47009 2.69995 9.49998 2.69995C13.5298 2.69995 16.9411 5.34854 18.0879 8.99992C16.9411 12.6513 13.5298 15.3 9.49995 15.3C5.47009 15.3 2.05884 12.6514 0.911987 8.99999ZM13.1 8.99995C13.1 10.9882 11.4882 12.6 9.50001 12.6C7.51178 12.6 5.90001 10.9882 5.90001 8.99995C5.90001 7.01173 7.51178 5.39995 9.50001 5.39995C11.4882 5.39995 13.1 7.01173 13.1 8.99995Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_922_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6d45ba87eeec0938ad57de81b0972515.svg";
export { ForwardRef as ReactComponent };